// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3d0H9","col":"styles_col__2IWZf"};